import React from 'react';
import DepartmentScreen from './DepartmentScreen';

function WickingScreen() {
  return (
    <DepartmentScreen
      department="wicking"
      departmentName="Wicking"
      nextDepartment="Pouring"
      color="#2196F3"
    />
  );
}

export default WickingScreen;